import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { ScreenCreationFormComponent } from '../../components/screen-creation-form/screen-creation-form.component';
import { Screen } from '~core/models/screen.models';
import { SharedModule } from '~app/app/~shared/modules/shared.module';

@Component({
  selector: 'screen-creation-dialog',
  standalone: true,
  imports: [ScreenCreationFormComponent, SharedModule],
  templateUrl: './screen-creation-dialog.component.html',
  styleUrl: './screen-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreenCreationDialogComponent extends BaseComponent {
  screen = input<Screen | null>(null);
}
